<template>
  <div>
    <div class="createdTitle-body">
      <img
        src="../../assets/image/screenImg/anquan.png"
        alt=""
        class="leftTopIcon"
      />
      <p class="createdTitle">安全管理</p>
      <screenNavigation
        class="screenNavigation"
        :name="createdName"
        ref="leftclick"
        v-clickoutside="handleClickOutside"
      ></screenNavigation>
    </div>
    <!-- ==========左侧区域========== -->
    <div class="leftBody">
      <div class="leftBody-title" style="padding-right: 0.8333vw">
        <img class="jiantou" src="../../assets/image/screenImg/jt.png" alt="" />
        <p class="title-txt">设备列表</p>
      </div>
      <!-- 头部盒子下方的线条 -->
      <div class="border-Max">
        <div class="border-left"></div>
        <div class="border-center"></div>
        <div class="border-right"></div>
      </div>
      <div class="leftBody-body" style="overflow: hidden">
        <div class="left-list-body" :class="{ anim: animate }">
          <div
            class="leftBody-body-list"
            v-for="(item, index) in elevatorList"
            :key="index"
            @click="endFun(item)"
          >
            <div class="jihuojiantou">
              <img
                src="../../assets/image/screenImg/jiantou.png"
                alt=""
                class="jihuojiantouimg"
                v-show="item.id == id"
              />
            </div>
            <p class="leftList-name">{{ item.name }}</p>
            <p class="leftList-num">序列号: {{ item.deviceId }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- ==========中心区域========== -->
    <div class="centerBody">
      <div class="centerTop">
        <div class="centerTop-title">
          <img
            class="jiantou"
            src="../../assets/image/screenImg/jt.png"
            alt=""
          />
          <p class="title-txt">升降机设备信息</p>
        </div>
        <div class="border-center-Max">
          <div class="border-center-left"></div>
          <div class="border-center-center"></div>
          <div class="border-center-right"></div>
        </div>
        <div class="centerTop-body flex">
          <div class="center-body-left">
            <p>
              是否超重：<span v-if="allPart.systemStatusWeight == '0'"
                >正常</span
              >
              <span
                v-else-if="
                  allPart.systemStatusWeight == '1' ||
                  allPart.systemStatusWeight == '2'
                "
              >
                超载
              </span>
            </p>
            <p>
              前门状态：<span>{{
                allPart.foreDoorStatus == '0' ? '开启' : '关闭'
              }}</span>
            </p>
            <p>
              后门状态：<span
                >{{ allPart.behindDoorStatus == '0' ? '开启' : '关闭' }}
              </span>
            </p>
            <p>
              额定载荷：<span>{{ allPart.ratedWeight || 0 }}</span>
            </p>
          </div>
          <div class="center-body-center">
            <p class="maxheight">
              最大高度 <span class="color-txt">{{ maxHeight || 0 }}F</span>
            </p>
            <p class="floor">
              最大楼层 <span class="color-txt">{{ floorNum || 0 }}m</span>
            </p>
            <!-- <div style="width:1vw;height:1vw;background:black"></div> -->
            <div class="img-leftBorder">
              <div class="img-leftBorder-top"></div>
              <div class="img-leftBorder-center"></div>
              <div class="img-leftBorder-bottom"></div>
            </div>
            <img
              src="../../assets/image/screenImg/lifticon.png"
              alt=""
              class="icon-img"
            />
          </div>
          <div class="center-body-right"></div>
        </div>
      </div>
      <div class="centerBottom">
        <div class="centerTop-title">
          <img
            class="jiantou"
            src="../../assets/image/screenImg/jt.png"
            alt=""
          />
          <p class="title-txt">预警统计</p>
        </div>
        <div class="border-center-Max">
          <div class="border-center-left"></div>
          <div class="border-center-center"></div>
          <div class="border-center-right"></div>
        </div>
        <div class="centerTop-body center-bottom-body"></div>
      </div>
    </div>
    <!-- ==========右侧区域========== -->
    <div class="rightBody">
      <div class="right-bottom">
        <div class="leftBody-title">
          <img
            class="jiantou"
            src="../../assets/image/screenImg/jt.png"
            alt=""
          />
          <p class="title-txt">升降机监控</p>
        </div>
        <div class="border-Max">
          <div class="border-left"></div>
          <div class="border-center"></div>
          <div class="border-right"></div>
        </div>
        <div class="right-bottom-body"></div>
      </div>
      <div class="right-top">
        <div class="leftBody-title">
          <img
            class="jiantou"
            src="../../assets/image/screenImg/jt.png"
            alt=""
          />
          <p class="title-txt">预警记录</p>
        </div>
        <div class="border-Max">
          <div class="border-left"></div>
          <div class="border-center"></div>
          <div class="border-right"></div>
        </div>
        <div class="rightBody-body" style="overflow: hidden; height: 18.4417vw">
          <div class="left-list-body ringhtArry" :class="{ anim2: animate2 }">
            <div
              class="rightBody-body-list"
              v-for="(item, index) in recordList"
              :key="index"
            >
              <!-- <p class="leftList-name">{{item.name}}</p>
<p class="leftList-num">序列号: {{item.imei}}</p> -->
              <p class="yj-title">
                {{ item.name + ', ' + item.val + item.unit }}
              </p>
              <p class="yj-right">{{ item.createDate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
import myHttp from '../../untils/port'
import util from '../../untils/util'
import screenHttp from '../../untils/screenHttp'
import base from '../../untils/base'
import screenNavigation from './screenNavigation.vue'
export default {
  directives: { Clickoutside },
  data() {
    return {
      heightCountList: [],
      speedCountList: [],
      tiltCountList: [],
      weightCountList: [],

      horList: [], //小时数组
      hourArryList: [], //每小时数据的数组
      createdName: '升降机监测',
      deviceId: '', //当前设备的序列号
      maxobj: {},
      floorNum: '', //最大楼层
      maxHeight: '', //最大高度
      allPart: {},
      id: '', //当前设备的id
      elevatorList: [], //设备列表
      animate2: false,
      animate: false,
      recordList: [], //预警记录数组
    }
  },
  created() {
    this.getEleListByPage()
  },
  components: {
    screenNavigation,
  },
  methods: {
    handleClickOutside() {
      this.$refs.leftclick.listShow = false
    },
    // 获取设备列表
    async getEleListByPage() {
      const data = await myHttp.getEleListByPage({
        projectId: util.session.get('groupId'),
      })
      if (data.data.code == 200) {
        this.elevatorList = data.data.data.elevatorList
        console.log('这是设备列表------>', this.elevatorList)
        if (this.elevatorList.length > 0) {
          this.timer = setInterval(this.scroll, 2000)
          this.id = this.elevatorList[0].id //当前设备的id
          this.deviceId = this.elevatorList[0].deviceId //当前设备的序列号
          this.getRealInfo() //获取升降机信息
          this.getHour() //获取预警记录
          this.getCountWarningOneDate() //获取预警统计
          // this.echartsA()
        }
      }
      console.log('设备列表接口信息------>', data)
    },
    scroll() {
      if (this.elevatorList.length > 12) {
        console.log('动画a')
        this.animate = true
        setTimeout(() => {
          this.elevatorList.push(this.elevatorList[0])
          this.elevatorList.shift()
          this.animate = false
        }, 1200)
      } else {
        window.clearInterval(this.timer)
      }
    },
    // 根据屏幕大小处理图标中字体大小的函数
    transformFontSize(fontsize) {
      // 获取屏幕宽度
      const width = window.screen.width
      const ratio = width / 1920
      // 取下整
      return parseInt(fontsize * ratio)
    },
    // 条形图
    echartsA(data, maxobj) {
      this.$echarts.init(document.querySelector('.center-body-right')).dispose()
      let charta = this.$echarts.init(
        document.querySelector('.center-body-right')
      )
      const that = this

      // charta.setOption
      let chartData = [
        {
          name: '当前高度',
          value: data.windspeed || 0,
        },
        {
          name: '当前速度',
          value: data.speed || 0, //米每秒
        },
        {
          name: '倾角度数',
          value: data.tilt || 0, //度
        },
      ]

      let yName = chartData.map((item) => item.name)
      let barWidth = 9
      let max = 0
      chartData.forEach((item) => {
        max = item.value > max ? Math.ceil(item.value / 100) * 100 : max
      })

      // 最大值
      let totalArray = [
        maxobj.heightSettingBean.heightEarlyWarning || 0,

        maxobj.heightSettingBean.speedEarlyWarning || 0,

        maxobj.tiltSettingBean.tiltEarlyWarning || 0,
      ]
      charta.setOption({
        animation: false,
        // backgroundColor: '#313131',
        xAxis: {
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        grid: {
          containLabel: true,
          left: 0,
          top: 20,
          right: 0,
          bottom: 0,
        },
        yAxis: [
          {
            inverse: true,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
              margin: 10,
              textStyle: {
                fontSize: this.transformFontSize(14),
                color: '#fff',
              },
            },
            data: yName,
          },
          {
            type: 'category',
            inverse: true,
            axisTick: 'none',
            axisLine: 'none',
            show: true,
            axisLabel: {
              textStyle: {
                color: '#ffffff',
                fontSize: '14',
              },
              align: 'right',
              padding: [0, 0, 0, 0],
              verticalAlign: 'bottom',
              lineHeight: 36,
              // 空闲车位、占比
              formatter: (value, index) => {
                let Arry = [' m', ' m/s', ' °']
                return `{a|${value}}` + Arry[index]
              },
              rich: {
                a: {
                  fontSize: this.transformFontSize(14),
                  padding: [0, 0, 0, 0],
                },
              },
            },
            data: chartData,
          },
        ],
        series: [
          {
            type: 'bar',
            barWidth,
            legendHoverLink: false,
            symbolRepeat: true,
            silent: true,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 1,
                    color: '#23D1A7', // 0% 处的颜色
                  },
                  {
                    offset: 0,
                    color: '#2ADCB1', // 100% 处的颜色
                  },
                ],
              },
            },
            data: chartData,
            zlevel: 1,
            animationEasing: 'elasticOut',
            label: {
              normal: {
                color: '#fff',
                show: true,
                position: [0, '-23px'],
                textStyle: {
                  fontSize: this.transformFontSize(14),
                  fontFamily: 'customFont',
                  color: '#FFFFFF',
                },
                // 柱图名称
                formatter: (value) => {
                  return value.name
                },
              },
            },
          },
          // 背景条形图
          {
            name: '背景',
            type: 'bar',
            barWidth: barWidth,
            barGap: '-100%',
            data: totalArray,
            itemStyle: {
              normal: {
                color: 'rgba(0, 35, 102, 0.2',
              },
            },
          },
          {
            type: 'pictorialBar',
            itemStyle: {
              color: '#000',
            },
            symbolRepeat: 'fixed',
            symbolMargin: 4,
            symbol: 'roundRect',
            symbolClip: true,
            symbolSize: [1, barWidth],
            symbolPosition: 'start',
            symbolOffset: [0, 0],
            data: chartData,
            zlevel: 2,
            animationEasing: 'elasticOut',
          },
        ],
      })

      window.addEventListener('resize', function () {
        charta.resize()
      })
    },
    // 获取升降机详情信息
    async getRealInfo() {
      const res = await myHttp.getEleInfoById({
        id: this.id,
      })
      console.log('当前升降机接口信息==========================>', res)
      console.log(
        '当前升降机信息==========================>',
        JSON.parse(res.data.data.elevator.baseSetting)
      )
      if (JSON.parse(res.data.data.elevator.baseSetting)) {
        // this.maxobj 储存升降机各参数预警值
        this.maxobj = JSON.parse(res.data.data.elevator.baseSetting)
        this.floorNum = JSON.parse(
          res.data.data.elevator.baseSetting
        ).heightSettingBean.floorNum
        this.maxHeight =
          parseFloat(this.floorNum) *
          parseFloat(
            JSON.parse(res.data.data.elevator.baseSetting).heightSettingBean
              .heightEachFloor
          )
        console.log('最大楼层---->', this.floorNum)
        console.log('最大高度---->', this.maxHeight)
      } else {
        this.floorNum = 0
        this.maxHeight = 0
      }
      this.allPart = res.data.data.elevator || {}
      console.log(this.allPart)

      setTimeout(() => {
        //console.log('===================>echarts第一次执行');
        // res.data.data.elevator是升降机当前各参数
        this.echartsA(this.allPart, this.maxobj)
        //console.log('===================>echarts第一次执行结束');
      }, 1000)
      // this.timeA = setTimeout(() => {
      //   this.getRealInfo()
      // }, 3000)
    },
    // 获取升降机预警记录
    getHour() {
      var that = this
      this.recordList = []
      myHttp
        .latelyWarnInformation({
          projectId: util.session.get('groupId'),
          deviceId: this.deviceId,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            //console.log('升降机预警记录接口信息==========================>', resp);
            var data = resp.data.data
            //高度预警
            let list = []
            var obj1 = data.latelyHeightWarn
            //console.log('升降机预警记录==========================>', obj1);
            if (obj1) {
              // obj1.icon = require('../../../assets/image/icon/gd.png')
              obj1.name = '高度预警'
              obj1.val = '数值' + parseFloat(obj1.height).toFixed(2)
              obj1.unit = 'm'
              list.push(obj1)
            }
            //速度预警
            var obj2 = data.latelySpeedWarn
            if (obj2) {
              // obj2.icon = require('../../../assets/image/icon/fs.png')
              obj2.name = '速度预警'
              obj2.val = '数值' + parseFloat(obj2.speed).toFixed(2)
              obj2.unit = 'm/s'
              list.push(obj2)
            }
            //姿态预警
            var obj3 = data.latelyTiltWarn
            if (obj3) {
              // obj3.icon = require('../../../assets/image/icon/qs.png')
              obj3.name = '倾角预警'
              obj3.val = '倾角' + parseFloat(obj3.tilt).toFixed(1)
              obj3.unit = '°'
              list.push(obj3)
            }
            //重量预警
            var obj4 = data.latelyWeightWarn
            if (obj4) {
              // obj4.icon = require('../../../assets/image/icon/kg.png')
              obj4.name = '重量预警'
              obj4.val = '数值' + parseFloat(obj4.weight).toFixed(2)
              obj4.unit = 'T'
              list.push(obj4)
            }

            that.recordList = list
            console.log(
              '预警记录集合数组============================>',
              that.recordList
            )
            // that.timer2 = setInterval(that.scroll2, 2000)
          }
        })
    },
    // 获取升降机预警信息统计
    async getCountWarningOneDate() {
      const data = await screenHttp.getCountWarningOneDate({
        projectId: util.session.get('groupId'),
        imeiId: this.deviceId,
      })
      if (data.data.code == 200) {
        let d = new Date()
        let hourNum = d.getHours()
        console.log('预警统计信息------》', data)
        console.log('当前小时----->', hourNum)
        const numList = data.data.data
        if (hourNum <= 12) {
          // 上午
          this.horList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
          this.hourArryList = numList.splice(0, 12)
          console.log(this.hourArryList)

          for (let index = 0; index < this.hourArryList.length; index++) {
            const element = this.hourArryList[index]
            this.heightCountList.push(element.heightCount||0)
            this.speedCountList.push(element.speedCount||0)
            this.tiltCountList.push(element.tiltCount||0)
            this.weightCountList.push(element.weightCount||0)
          }
          this.echs()
        } else if (hourNum > 12) {
          //下午
          this.horList = [12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
          this.hourArryList = numList.splice(12, 25)
          for (let index = 0; index < this.hourArryList.length; index++) {
            const element = this.hourArryList[index]
            this.heightCountList.push(element.heightCount||0)//高度预警
            this.speedCountList.push(element.speedCount||0)//速度
            this.tiltCountList.push(element.tiltCount||0)//倾角
            this.weightCountList.push(element.weightCount||0)//重量
          }
          this.echs()
        }
      }
    },
    // 预警统计图表

    echs() {
      this.$echarts
        .init(document.querySelector('.center-bottom-body'))
        .dispose()
      let chartb = this.$echarts.init(
        document.querySelector('.center-bottom-body')
      )
      let XData = this.horList
      let valueData = {
        data1:this.weightCountList,
        data2:  this.tiltCountList,
        data3: this.heightCountList,
        data4: this.speedCountList,
      }

      let option = {
        // backgroundColor:false,
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          color: ['#5553D3', '#ADE8FF', '#1CAFCC','#2074DA'],
          right: '2%',
          top: '2%',
          textStyle: {
            color: '#fff',
          },
        },
        grid: {
          top: 'middle',
          left: '3%',
          right: '4%',
          bottom: '3%',
          height: '80%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: XData,
          axisLine: {
            lineStyle: {
              color: '#FFFFFF',
            },
          },
          axisLabel: {
            textStyle: {
              color: '#FFFF',
            },
          },
        },
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              textStyle: {
                color: '#FFFF',
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#FFFF',
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#FFFF',
              },
            },
          },
        ],
        series: [
          {
            name: '重量',
            type: 'line',
            data: valueData.data1,
            color: '#0C10F8',
            symbol: 'emptyCircle', //标记的图形为实心圆
            symbolSize: 9, //标记的大小
            lineStyle: {
              normal: {
                width: 2,
                color: {
                  type: 'linear',
                  colorStops: [
                    {
                      offset: 0,
                      color: '#0C10F8', // 0% 处的颜色
                    },
                    {
                      offset: 0.4,
                      color: '#0C10F8', // 100% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#0C10F8', // 100% 处的颜色
                    },
                  ],
                  globalCoord: false, // 缺省为 false
                },
                // shadowColor: '#0C10F8',
                // shadowBlur: 10,
                // shadowOffsetY: 7
              },
            },
            itemStyle: {
              normal: {
                // color: '#0C10F8',
                // background:'#0C10F8',
                borderColor: '#0C10F8',
                borderWidth: 1,
              },
            },
            emphasis: {
              // 鼠标hover上去的时候，拐点的颜色和样式
              itemStyle: {
                // color: '#0C10F8', //颜色
                //  borderColor: '#fff', //图形的描边颜色
                //  borderWidth: 2, // 描边的线宽
                // shadowBlur: 4, // 图形的阴影大小
                // shadowColor: '#0C10F8', // 图形的阴影颜色
              },
            },
            smooth: false,
          },
          {
            name: '倾角',
            type: 'line',
            data: valueData.data2,
            color: '#114DD6',
            symbol: 'emptyCircle', //标记的图形为实心圆
            symbolSize: 9, //标记的大小
            lineStyle: {
              normal: {
                width: 2,
                color: {
                  type: 'linear',
                  colorStops: [
                    {
                      offset: 0,
                      color: '#114DD6', // 0% 处的颜色
                    },
                    {
                      offset: 0.4,
                      color: '#114DD6', // 100% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#114DD6', // 100% 处的颜色
                    },
                  ],
                  globalCoord: false, // 缺省为 false
                },
                // shadowColor: '#114DD6',
                // shadowBlur: 10,
                // shadowOffsetY: 7
              },
            },
            itemStyle: {
              normal: {
                // color: '#114DD6',
                // background:'#114DD6',
                borderColor: '#114DD6',
                borderWidth: 1,
              },
            },
            emphasis: {
              // 鼠标hover上去的时候，拐点的颜色和样式
              itemStyle: {
                // color: '#114DD6', //颜色
                //  borderColor: '#fff', //图形的描边颜色
                //  borderWidth: 2, // 描边的线宽
                // shadowBlur: 4, // 图形的阴影大小
                // shadowColor: '#114DD6', // 图形的阴影颜色
              },
            },
            smooth: false,
          },
          {
            name: '高度',
            type: 'line',
            data: valueData.data3,
            color: '#0EB5F7',
            symbol: 'emptyCircle', //标记的图形为实心圆
            symbolSize: 9, //标记的大小
            lineStyle: {
              normal: {
                width: 2,
                color: {
                  type: 'linear',
                  colorStops: [
                    {
                      offset: 0,
                      color: '#0EB5F7', // 0% 处的颜色
                    },
                    {
                      offset: 0.4,
                      color: '#0EB5F7', // 100% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#0EB5F7', // 100% 处的颜色
                    },
                  ],
                  globalCoord: false, // 缺省为 false
                },
                // shadowColor: '#0EB5F7',
                // shadowBlur: 10,
                // shadowOffsetY: 7
              },
            },
            itemStyle: {
              normal: {
                // color: '#0EB5F7',
                // background:'#0EB5F7',
                borderColor: '#0EB5F7',
                borderWidth: 1,
              },
            },
            emphasis: {
              // 鼠标hover上去的时候，拐点的颜色和样式
              itemStyle: {
                // color: '#0EB5F7', //颜色
                //  borderColor: '#fff', //图形的描边颜色
                //  borderWidth: 2, // 描边的线宽
                // shadowBlur: 4, // 图形的阴影大小
                // shadowColor: '#0EB5F7', // 图形的阴影颜色
              },
            },
            smooth: false,
          },
          {
            name: '速度',
            type: 'line',
            data: valueData.data4,
            color: '#4072ED',
            symbol: 'emptyCircle', //标记的图形为实心圆
            symbolSize: 9, //标记的大小
            lineStyle: {
              normal: {
                width: 2,
                color: {
                  type: 'linear',
                  colorStops: [
                    {
                      offset: 0,
                      color: '#4072ED', // 0% 处的颜色
                    },
                    {
                      offset: 0.4,
                      color: '#4072ED', // 100% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#4072ED', // 100% 处的颜色
                    },
                  ],
                  globalCoord: false, // 缺省为 false
                },
                // shadowColor: '#4072ED',
                // shadowBlur: 10,
                // shadowOffsetY: 7
              },
            },
            itemStyle: {
              normal: {
                // color: '#4072ED',
                // background:'#4072ED',
                borderColor: '#4072ED',
                borderWidth: 1,
              },
            },
            emphasis: {
              // 鼠标hover上去的时候，拐点的颜色和样式
              itemStyle: {
                // color: '#4072ED', //颜色
                //  borderColor: '#fff', //图形的描边颜色
                //  borderWidth: 2, // 描边的线宽
                // shadowBlur: 4, // 图形的阴影大小
                // shadowColor: '#4072ED', // 图形的阴影颜色
              },
            },
            smooth: false,
          },
        ],
      }
      chartb.setOption(option)
      window.addEventListener('resize', function () {
        chartb.resize()
      })
    },
    // 切换设备处理函数
    endFun(item) {
      console.log('当前设备信息-------->', item)
      this.deviceId = item.deviceId
      this.id = item.id
      this.getRealInfo() //获取升降机信息
      this.getHour() //获取预警记录
    },
  },
}
</script>

<style scoped>
.maxBody {
}
.leftBody {
  width: 24.7917vw;
  height: 44.7917vw;
  /* background: pink; */
  float: left;
  margin-left: 1.25vw;
  z-index: 99;
}
.centerBody {
  width: 41.6667vw;
  height: 44.7917vw;
  /* background:black; */
  float: left;
  margin-left: 3.125vw;
}
.rightBody {
  width: 24.7917vw;
  height: 44.7917vw;
  /* background: pink; */
  float: left;
  margin-left: 3.125vw;
}
.leftBody-title {
  width: 24.7917vw;
  height: 2.0833vw;
  background: linear-gradient(
    90deg,
    #0b213c 0%,
    #0a1b35 50%,
    rgba(11, 22, 47, 0.1) 100%,
    #0a1730 100%
  );
  text-align: left;
  line-height: 2.0833vw;
}
.jiantou {
  float: left;
  width: 2.3021vw;
  height: 1.1021vw;
  margin-top: 0.45vw;
}
.title-txt {
  font-family: PingFang SC;
  font-size: 0.9375vw;
  font-weight: normal;
  letter-spacing: 0em;

  color: #ffffff;
  float: left;
}
.leftBody-body {
  height: 41.7025vw;
  width: 24.7917vw;
  /* background: pink; */
  padding-top: 0.5208vw;
  overflow: hidden;
}
.leftBody-body-list {
  padding-top: 0.2083vw;

  text-align: left;
  width: 24.7917vw;
  height: 2.9167vw;
  border: 0.0521vw solid;
  border-right: 0;
  border-left: 0;
  /* border-image: linear-gradient(270deg, rgba(140,180,231,0.00) 0%, #61A3F6 52%, rgba(140,180,231,0.00) 100%) 1; */
  margin-bottom: 0.5208vw;
  background: linear-gradient(
    270deg,
    rgba(79, 102, 131, 0) 0%,
    #142a4f 52%,
    rgba(79, 102, 131, 0) 100%
  );
  cursor: pointer;
}
.left-list-body {
  width: 100%;
  height: 110%;
  /* background: #0B213C; */
}
.centerTop {
  width: 41.6667vw;
  height: 20.8333vw;

  margin-bottom: 3.125vw;
}
.centerBottom {
  width: 41.6667vw;
  height: 20.8333vw;
}
.centerTop-title {
  width: 41.6667vw;
  height: 2.0833vw;
  background: linear-gradient(
    90deg,
    #0b213c 0%,
    #0a1b35 50%,
    rgba(11, 22, 47, 0.1) 100%,
    #0a1730 100%
  );
  text-align: left;
  line-height: 2.0833vw;
}
.centerTop-body {
  width: 41.6667vw;
  height: 18.5417vw;
  background: rgba(0, 35, 102, 0.2);
}
.right-top {
  width: 24.7917vw;
  height: 20.8333vw;
  /* background:black ; */
}
.right-bottom {
  width: 24.7917vw;
  height: 20.8333vw;
  /* background:black; */
  margin-bottom: 3.135vw;
}
.leftList-name {
  font-family: PingFang SC;
  font-size: 0.8333vw;
  font-weight: normal;
  letter-spacing: 0em;
  margin-bottom: 0.2083vw;
  color: #ffffff;
}
.leftList-num {
  font-family: PingFang SC;
  font-size: 0.7292vw;
  font-weight: normal;
  letter-spacing: 0em;

  color: #ffffff;
}
.anim {
  margin-top: -3.52vw;
  transition: all 1s;
}
.anim2 {
  margin-top: -2.0833vw;
  transition: all 1s;
}

.rightBody-body {
  width: 100%;
  height: 18.5417vw;
  background: rgba(0, 35, 102, 0.2);
  margin-bottom: 1.0417vw;
}
.rightBody-body-list {
  padding-top: 0.2083vw;
  padding-left: 0.8333vw;
  text-align: left;
  width: 24.7917vw;
  height: 2.0833vw;
  border: 0.0521vw solid;
  /* border-image: linear-gradient(270deg, rgba(140,180,231,0.00) 0%, #61A3F6 52%, rgba(140,180,231,0.00) 100%) 1; */

  background: linear-gradient(
    270deg,
    rgba(79, 102, 131, 0) 0%,
    #142a4f 52%,
    rgba(79, 102, 131, 0) 100%
  );
}
.ringhtArry {
}
.yj-title {
  float: left;
  width: 40%;

  font-family: PingFang SC;
  font-size: 0.7292vw;
  font-weight: normal;
  letter-spacing: 0em;

  color: #ff0000;
  line-height: 1.733vw;
}
.yj-right {
  float: right;
  width: 40%;
  font-family: PingFang SC;
  font-size: 0.7292vw;
  font-weight: normal;
  letter-spacing: 0em;

  color: #ffffff;
  line-height: 1.733vw;
}
.gaoguang {
  color: #01fdfc;
}
.right-bottom-body {
  width: 24.7917vw;
  height: 18.6417vw;

  background: rgba(0, 35, 102, 0.2);
}
.border-Max {
  margin-top: 0.1042vw;
}
.border-left {
  width: 0.3646vw;
  height: 0.1042vw;
  background: #518fe3;
  float: left;
  margin-right: 0.2083vw;
}
.border-center {
  width: 23.6458vw;
  height: 0.1042vw;
  background: linear-gradient(90deg, #11273f 0%, #608cca 52%, #040d1f 100%);
  float: left;
  margin-right: 0.2083vw;
}
.border-right {
  width: 0.3646vw;
  height: 0.1042vw;
  background: #518fe3;
  float: left;
}
.border-center-Max {
  margin-top: 0.1042vw;
}
.border-center-left {
  width: 0.3646vw;
  height: 0.1042vw;
  background: #518fe3;
  float: left;
  margin-right: 0.2083vw;
}
.border-center-center {
  width: 40.5208vw;
  height: 0.1042vw;
  background: linear-gradient(90deg, #11273f 0%, #608cca 52%, #040d1f 100%);
  float: left;
  margin-right: 0.2083vw;
}
.border-center-right {
  width: 0.3646vw;
  height: 0.1042vw;
  background: #518fe3;
  float: left;
}
.flex {
  display: flex;
}
.center-body-left {
  padding-top: 1.25vw;
  margin-left: 1.25vw;
  width: 7.1458vw;
  height: 100%;

  margin-right: 3.5833vw;
}
.center-body-left p {
  text-align: left;
  font-family: PingFang SC;
  font-size: 0.7292vw;
  font-weight: normal;
  letter-spacing: 0em;
  margin-bottom: 0.625vw;
  color: #ffffff;
}
.center-body-left span {
  color: #02f4fc;
}

.center-body-center {
  position: relative;
  width: 14.8021vw;
  height: 100%;

  margin-right: 3.375vw;
  padding-top: 2.3438vw;
}
.maxheight {
  position: absolute;
  top: 7.2917vw;
  ont-family: PingFang SC;
  font-size: 0.7292vw;
  font-weight: normal;
  letter-spacing: 0em;
  color: #ffffff;
  text-shadow: 0px 0.2083vw 0.5208vw 0px rgba(2, 244, 252, 0.3);
  left: -1.1208vw;
}
.floor {
  position: absolute;
  top: 9.2188vw;
  left: -1.1208vw;
  ont-family: PingFang SC;
  font-size: 0.7292vw;
  font-weight: normal;
  letter-spacing: 0em;
  color: #ffffff;
  text-shadow: 0px 0.2083vw 0.5208vw 0px rgba(2, 244, 252, 0.3);
}

.center-body-right {
  width: 10.4167vw;
  height: 10rem;
}
.icon-img {
  float: right;
  margin-right: 2vw;
  width: 8.125vw;
  height: 14.6354vw;
}
.img-leftBorder {
  width: 0.8333vw;
  height: 14.6354vw;
  float: left;
  margin-left: 3.0625vw;
}
.img-leftBorder-top,
.img-leftBorder-bottom {
  width: 0.8333vw;
  height: 0.0521vw;
  background: #02f4fc;
}
.img-leftBorder-center {
  height: 14.2708vw;
  width: 0.0521vw;
  border-left: #01fdfc dashed 0.0521vw;
  margin-left: 0.415vw;
}
.color-txt {
  color: #02f4fc;
}
.jihuojiantou {
  margin-top: 0.3vw;
  margin-right: 1.0417vw;
  float: left;
  width: 1.7188vw;
  height: 1.5625vw;
}
.jihuojiantouimg {
  width: 1.7188vw;
  height: 1.5625vw;
}
.leftTopIcon {
  width: 1.8115vw;
  height: 1.8115vw;
  margin-right: 0.6563vw;
}
</style>
<style scoped>
@import '../../untils/screenTop.css';
</style>